import React from 'react';
import { somethingWrongMsg } from '../../utils/messages';
import { webConfig } from '../../utils/webConfig';
import { Button } from '../ui';

const handleClick = () => {
    window.location.href = webConfig.mainSearchSite;
};

export const SomethingWentWrong: React.FC = () => {
    return (
        <div className="flex flex-col gap-6 py-8 max-w-[412px] mx-auto text-center">
            <div className="text-body-medium text-secondary">
                {somethingWrongMsg}
            </div>
            <Button
                type="submit"
                onClick={handleClick}
            >
                Search an organization
            </Button>
        </div>
    );
};

export default SomethingWentWrong;
